import { required } from '@jfs/ui-new'
import { Dropdown } from '../../components/Dropdown'
import { CardSchema, CardTypes, getSchemaData } from '../../utils/constants'

const statusData = [
  { id: 1, value: 'Enable' },
  { id: 2, value: 'Disable' },
]

export const formData: any = (
  addCard: (values: any) => void,
  entityIdMap: any,
  cardSchemaData: any,
  cardTypeData: any,
) => [
  {
    key: 'entityInfo',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'entityId',
            ComponentName: Dropdown,
            title: 'Entity',
            validationSchema: required,
            data: entityIdMap,
          },
          {
            fieldName: 'scheme',
            ComponentName: Dropdown,
            title: 'scheme',
            validationSchema: required,
            data: getSchemaData(cardSchemaData ?? CardSchema),
          },
          {
            fieldName: 'cardType',
            ComponentName: Dropdown,
            title: 'Type',
            validationSchema: required,
            data: getSchemaData(cardTypeData ?? CardTypes),
          },
          {
            fieldName: 'status',
            ComponentName: Dropdown,
            title: 'Status',
            validationSchema: required,
            data: statusData,
          },
        ],
      },
    ],
    horizontalFlex: 1,
    onSubmit: async (values: any) => {
      addCard(values)
      return 'endPointDetails'
    },
    actionTitle: 'Add Mapping',
  },
]
